module.exports = __webpack_public_path__ + "static/media/group_active.bba6e3bf.svg";